import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { Form, Input, InputNumber, Select } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../common/components/simpleInput";
import { useQueryUserRoleForSelect } from "./core/_hooks";
import { UserService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { DynamicUploadImage } from "../../../common/components/Upload/DynamicUploadImage";
import { log } from "console";

type UserFormType = {
  onFinish: () => void;
  initialValue?: any;
};

const UserForm = ({ onFinish, initialValue }: UserFormType) => {
  const [form] = Form.useForm();

  const { data: roleOptions, isLoading: isLoadingRole } =
    useQueryUserRoleForSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      console.log("initialValue", initialValue);

      form.setFieldsValue({
        ...initialValue,
        userRole: initialValue?.userRole
          ? {
              label: initialValue?.userRole?.name,
              value: initialValue?.userRole?.["@id"],
            }
          : null,
        image: initialValue?.image
          ? {
              value: initialValue.image?.["@id"],
              label: initialValue?.image?.basename,
              url: initialValue?.image?.contentUrl,
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        userRole: values.userRole.value,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        image: values?.image?.value ? values?.image?.value : null,
      };

      if (!dataToPost?.id) {
        const res = await UserService.postUser(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await UserService.updateUser(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className="px-3 mb-4 d-flex align-items-center justify-content-center">
          <SimpleInput
            Form={Form}
            name="image"
            customInput={<DynamicUploadImage name="image" form={form} />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Adresse email"
                name={"email"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                  {
                    type: "email",
                    message: "Veuillez entrer une adresse email valide",
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Nom"
                name={"firstname"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Mot de passe"
                name={"plainPassword"}
                rules={[
                  {
                    required: !initialValue,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input.Password />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Prénom"
                name={"lastname"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Rôle"
                name={"userRole"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={roleOptions}
                    loading={isLoadingRole}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};

export default UserForm;
